import React from "react";
import { BonusesSection } from "./components/BonusesSection";
import { FaqSection } from "./components/FaqSection";
import { Footer } from "./components/Footer";
import { Hero } from "./components/Hero";
import { LaunchBar } from "./components/LaunchBar";
import { OfferSection } from "./components/OfferSection";
import { ReceiveSection } from "./components/ReceiveSection";
import { SocialProofSection } from "./components/SocialProofSection";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#090B0D] font-heading" data-id="element-0" data-mp="2mlubatj25zve">
      <LaunchBar data-id="element-1" data-mp="2mjzo18kbdvo5" />
      <main data-id="element-2" data-mp="31agoaol7qfjg">
        <Hero data-id="element-3" data-mp="31b8fzobovt4g" />
        <SocialProofSection data-id="element-4" data-mp="31bs09botatln" />
        <ReceiveSection data-id="element-5" data-mp="31c1iue7j1yhb" />
        <BonusesSection data-id="element-6" data-mp="2wk0b95lb0vxm" />
        <OfferSection data-id="element-7" data-mp="2wjqhr811w6n6" />
        <FaqSection data-id="element-8" data-mp="2wj8f9tnsow6t" />
      </main>
      <Footer data-id="element-9" data-mp="2wi5mthatqlos" />
    </div>;
}